import { TYPES } from '../../common/constants';
import * as client from '../../services/client';
import {
  startFormLoading,
  startPRLoading,
  stopFormLoading,
  stopPRLoading,
} from './loader';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

export const setHomeownerOnboardingFormData = (payload) => ({
  type: TYPES.HOMEOWNER_ONBOARDING_FORM_DATA,
  payload,
});
export const clearsetHomeownerOnboardingFormData = () => ({
  type: TYPES.CLEAR_HOMEOWNER_ONBOARDING_FORM_DATA,
});

export const saveHomeOwnerOnboarding = (params) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .saveHomeOwnerOnboarding(params)
    .then((response) => {
      dispatch(stopFormLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson && responsejson.statusCode === 200) {
            dispatch(clearsetHomeownerOnboardingFormData());
            dispatch(fetchHomeOwnerOnboarding(params.PropertyId));
            dispatch(
              setHomeownerOnboardingFormData({ propertyId: params.PropertyId })
            );
            toast.success(
              ` ⓘ Homeowner onboarding ${params && params.id ? 'updated' : 'created'} successfully.`,
              { autoClose: 10000, position: 'top-center' }
            );
          } else if (responsejson.statusCode === 402) {
            toast.error(
              `🚫 Order title already exist, please use different one.`,
              { autoClose: 12000, position: 'top-center' }
            );
          } else {
            toast.error(
              `🚫 Homeowner onboarding ${params && params.id ? 'updating' : 'creating'} failed, please try again.`,
              { autoClose: 12000, position: 'top-center' }
            );
          }
        });
      } else {
        toast.error(
          `🚫 Homeowner onboarding ${params && params.id ? 'updating' : 'creating'} failed, please try again.`,
          { autoClose: 12000, position: 'top-center' }
        );
      }
    })
    .catch(() => {
      toast.error(
        `🚫 Something went wrong with ${params && params.id ? 'updating' : 'creating'} homeowner onboarding, please try again.`,
        { autoClose: 12000, position: 'top-center' }
      );
    });
};

export const fetchHomeOwnerOnboarding = (propertyId) => (dispatch) => {
  dispatch(startPRLoading());
  return client.fetchHomeOwnerOnboarding(propertyId).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        if (responsejson && responsejson.statusCode === 200) {
          if (responsejson && responsejson.data.length > 0) {
            let title = responsejson.data[0].suiteOnBoardingTitle
              ? responsejson.data[0].suiteOnBoardingTitle
              : '';
            dispatch(
              setHomeownerOnboardingFormData({ suiteOnBoardingTitle: title })
            );
          }
          dispatch({
            type: TYPES.FETCH_HOMEOWNER_ONBOARDING_DATA,
            payload: responsejson.data,
          });
          dispatch(stopPRLoading());
        }
      });
    }
  });
};

export const onDeleteOrder = (orderId, userId) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .onDeleteOrder(orderId, userId)
    .then((response) => {
      dispatch(stopFormLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson && responsejson.statusCode === 200) {
            toast.success(
              ` ⓘ Homeowner onboarding order deleted successfully.`,
              { autoClose: 10000, position: 'top-center' }
            );
            dispatch({
              type: TYPES.DELETE_HOMEOWNER_ONBOARDING_ORDER_DATA,
              payload: orderId,
            });
          } else {
            toast.error(` ⓘ Homeowner onboarding order deleting failed.`, {
              autoClose: 10000,
              position: 'top-center',
            });
          }
        });
      } else {
        toast.error(` ⓘ Homeowner onboarding order deleting failed.`, {
          autoClose: 10000,
          position: 'top-center',
        });
      }
    })
    .catch(() => {
      dispatch(stopFormLoading());
      toast.error(` ⓘ Homeowner onboarding order deleting failed.`, {
        autoClose: 10000,
        position: 'top-center',
      });
    });
};

export const clearHomeOwnerOnboarding = () => (dispatch) => {
  dispatch({
    type: TYPES.CLEAR_HOMEOWNER_ONBOARDING_DATA,
  });
};
export const changeOrdersSequence = (params) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .changeOrdersSequence(params)
    .then((response) => {
      dispatch(stopFormLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson && responsejson.statusCode === 200) {
            dispatch({
              type: TYPES.FETCH_HOMEOWNER_ONBOARDING_DATA,
              payload: responsejson.data,
            });
          } else {
          }
        });
      } else {
        toast.error(`🚫 Something went wrong, please try again.`, {
          autoClose: 12000,
          position: 'top-center',
        });
      }
    })
    .catch(() => {
      dispatch(stopFormLoading());
      toast.error(`🚫 Something went wrong, please try again.`, {
        autoClose: 12000,
        position: 'top-center',
      });
    });
};

export const onUpdateSuiteOnBoardingFAQsOrder =
  (params, faqs) => (dispatch) => {
    return client.updateSuiteOnBoardingFAQsOrder(params).then((response) => {
      if (response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson && responsejson.statusCode === 200) {
            let data = faqs.filter((faq) => !faq.id);
            dispatch(
              setHomeownerOnboardingFormData({
                faqs: [...responsejson.data, ...data],
              })
            );
          } else {
          }
        });
      }
    });
  };

export const onUpdateSuiteOnBoardingChecklistsOrder =
  (params, checklists) => (dispatch) => {
    return client
      .updateSuiteOnBoardingChecklistsOrder(params)
      .then((response) => {
        if (response.status === 200) {
          response.json().then((responsejson) => {
            if (responsejson && responsejson.statusCode === 200) {
              let data = checklists.filter((cl) => !cl.id);
              dispatch(
                setHomeownerOnboardingFormData({
                  checklists: [...responsejson.data, ...data],
                })
              );
            } else {
            }
          });
        }
      });
  };

export const onUpdateSuiteOnBoardingKeysOrder =
  (params, keys) => (dispatch) => {
    return client.updateSuiteOnBoardingKeysOrder(params).then((response) => {
      if (response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson && responsejson.statusCode === 200) {
            let data = keys.filter((key) => !key.id);
            dispatch(
              setHomeownerOnboardingFormData({
                keys: [...responsejson.data, ...data],
              })
            );
          } else {
          }
        });
      }
    });
  };
export const onUpdateSuiteOnBoardingOffersOrder =
  (params, offers) => (dispatch) => {
    return client.updateSuiteOnBoardingOffersOrder(params).then((response) => {
      if (response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson && responsejson.statusCode === 200) {
            let data = offers.filter((key) => !key.id);
            let offers1;
            if (responsejson.data && responsejson.data.length > 0) {
              offers1 = responsejson.data.map((offer) => {
                let descriptionState = offer.description
                  ? offer.description
                  : '';
                return {
                  ...offer,
                  description: descriptionState,
                  descriptionEditor: offer.description,
                  image: offer.logo ? offer.logo : '',
                  logo: [offer.logo],
                };
              });
              dispatch(
                setHomeownerOnboardingFormData({
                  offers: [...offers1, ...data],
                })
              );
            }
          } else {
          }
        });
      }
    });
  };
export const fetchPropertyStages = (propertyId) => (dispatch) => {
  return client
    .fetchPropertyStages(propertyId)
    .then((response) => {
      dispatch(stopFormLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson && responsejson.length > 0) {
            dispatch({
              type: TYPES.FETCH_CONSTRUCTION_STAGES_DONE,
              payload: responsejson,
            });
          } else {
            dispatch({
              type: TYPES.FETCH_CONSTRUCTION_STAGES_DONE,
              payload: [],
            });
          }
        });
      } else {
        dispatch({
          type: TYPES.FETCH_CONSTRUCTION_STAGES_DONE,
          payload: [],
        });
      }
    })
    .catch(() => {
      dispatch({
        type: TYPES.FETCH_CONSTRUCTION_STAGES_DONE,
        payload: [],
      });
    });
};
export const clearConstructionStages = () => (dispatch) => {
  dispatch({
    type: TYPES.CLEAR_CONSTRUCTION_STAGES_DONE,
  });
};
